import { TFunction } from "i18next";
import * as Yup from "yup";

export const EmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const PhonePattern = /^(\+\d+|0\d+)$/;
export const DigitsPattern = /^\d+$/;
export const ZipCodePattern = /^\d+$/;
export const FileNumberShortPattern = /^[0-9]{1,3} [a-zA-Z]{1,3} [0-9]{1,5}\/[0-9]{2}[a-zA-Z]?$/;

// PhoneNumber.MinDigits / MaxDigits in the backend. The bounds hold for the canonical "+43…" form the
// number is stored as, so a national "0664…" counts with its country code and "0043…" without the 00.
const PhoneNumberDigits = { min: 7, max: 15 };
const AustriaCountryCode = "43";

function canonicalPhoneDigitCount(value: string): number {
  const digits = value.replace(/\D/g, "");
  if (digits.startsWith("00")) {
    return digits.length - "00".length;
  }
  if (digits.startsWith("0")) {
    return digits.length - "0".length + AustriaCountryCode.length;
  }
  return digits.length;
}

// The rule the backend stores and texts a number by; a form chains its own field length and conditions.
export const phoneNumberValidation = (t: TFunction) =>
  Yup.string()
    .matches(PhonePattern, { message: t("clients.create.phoneInvalid"), excludeEmptyString: true })
    .test("phone-digits", t("clients.create.phoneInvalid"), (value) => {
      if (!value) {
        return true;
      }
      const digits = canonicalPhoneDigitCount(value);
      return digits >= PhoneNumberDigits.min && digits <= PhoneNumberDigits.max;
    });
